import { useEffect, useRef, useState } from "react";

import { discountType } from "../../utils/constants";

import down from '../../assets/images/icondropdown.svg'

import styles from "../../Pages/Coupon/coupon.module.css";

const CouponGeneralDetail = ({ couponData, setCouponData, types, error, setError }) => {

    const dropdownRef = useRef()
    const [openDropdwn, setOpenDropdown] = useState(false);

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const formattedTomorrow = tomorrow.toISOString().split("T")[0];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (value) => {
        setCouponData(prev => ({
            ...prev,
            discountType: value
        }));
        setOpenDropdown(false);
    };

    const formatDateForInput = (date) => {
        if (!date) return "";
        return new Date(date).toISOString().split("T")[0];
    };

    return (
        <div className={styles.generalContainer}>
            <div className={styles.discountType}>
                <label className={styles.label}>Discount type</label>
                <div className="dropdown-wrapper" ref={dropdownRef}>

                    <div className="dropdown-header" onClick={() => setOpenDropdown(!openDropdwn)}>
                        <span className="title">{discountType[couponData?.discountType] || 'Select discount type'}</span>
                        <span className={`arrow ${openDropdwn ? "rotate" : ""}`}>
                            <img src={down} alt="down-image"/>
                        </span>
                    </div>
                    {error.discountType && <span className="error-message">{error.discountType}</span>}

                    {openDropdwn && (
                        <div className="dropdown-list">
                            {Object.entries(types).map(([key, label]) => (
                                <label
                                    key={key}
                                    className={`dropdown-item ${couponData?.discountType === key ? "active" : ""}`}
                                    onClick={() => handleSelect(key)}
                                >
                                    <span>{label}</span>
                                </label>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.discountType}>
                <label className={styles.label}>Coupon amount</label>
                <div className={styles.inputField}>
                    <input type="number" value={couponData?.couponAmount} placeholder="Enter coupon amount" className={styles.couponAmount}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value < 0) return; // Prevent negative values
                            setCouponData(prev => ({
                                ...prev,
                                couponAmount: value
                            }));
                            setError(prev => ({ ...prev, couponAmount: "" }));
                        }
                        }
                        min={0}
                        step="0.01"
                    />
                    {error.couponAmount && <p className="error-message">{error.couponAmount}</p>}
                </div>
            </div>

            <div className={styles.discountType}>
                <label className={styles.label}>Coupon expiry date</label>
                <div>
                    <input
                        type="date"
                        className={styles.expiryDate}
                        defaultValue={formattedTomorrow}
                        value={formatDateForInput(couponData?.couponExpiryDate)}
                        min={formattedTomorrow}
                        onChange={(e) => {
                            setCouponData(prev => ({
                                ...prev,
                                couponExpiryDate: e.target.value
                            }));
                            setError(prev => ({ ...prev, couponExpiryDate: "" }));
                        }}
                    />
                    {error.couponExpiryDate && <p className="error-message">{error.couponExpiryDate}</p>}
                </div>
            </div>


        </div>
    );
};

export default CouponGeneralDetail;
